import * as React from 'react';
import {Provider} from 'react-redux';

import {store} from '../../store';

import {Trash} from './trash';

export class TrashPage extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <Provider store={store}>
                <Trash />
            </Provider>
        );
    }
}
